import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { LangProvider } from "@/lib/i18n";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import Home from "@/pages/Home";
import Browse from "@/pages/Browse";
import CompanionProfile from "@/pages/CompanionProfile";
import Checkout from "@/pages/Checkout";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import BecomeCompanion from "@/pages/BecomeCompanion";
import Dashboard from "@/pages/Dashboard";
import CompanionDashboard from "@/pages/CompanionDashboard";
import Admin from "@/pages/Admin";
import Policy from "@/pages/Policy";
import Support from "@/pages/Support";
import ForgotPassword from "@/pages/ForgotPassword";
import { MustChangeBanner } from "@/components/MustChangeBanner";

const PRIVATE = /^\/(dashboard|companion$|admin|checkout|login|register)/;

const ScrollTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
    let m = document.querySelector('meta[name="robots"]');
    if (!m) {
      m = document.createElement("meta");
      m.name = "robots";
      document.head.appendChild(m);
    }
    m.content = PRIVATE.test(pathname) ? "noindex, nofollow" : "index, follow";
  }, [pathname]);
  return null;
};

function App() {
  return (
    <div className="App">
      <LangProvider>
        <AuthProvider>
          <BrowserRouter>
            <ScrollTop />
            <Header />
            <MustChangeBanner />
            <main className="flex-1 flex flex-col">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/companions" element={<Browse />} />
                <Route path="/companions/:id" element={<CompanionProfile />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/become-companion" element={<BecomeCompanion />} />
                <Route path="/support" element={<Support />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/:slug" element={<Policy />} />
                <Route path="/checkout/:id" element={<ProtectedRoute roles={["customer"]}><Checkout /></ProtectedRoute>} />
                <Route path="/dashboard" element={<ProtectedRoute roles={["customer"]}><Dashboard /></ProtectedRoute>} />
                <Route path="/companion" element={<ProtectedRoute roles={["companion"]}><CompanionDashboard /></ProtectedRoute>} />
                <Route path="/admin" element={<ProtectedRoute roles={["admin", "moderator"]}><Admin /></ProtectedRoute>} />
              </Routes>
            </main>
            <Footer />
            <Toaster position="top-center" richColors />
          </BrowserRouter>
        </AuthProvider>
      </LangProvider>
    </div>
  );
}

export default App;
